export const PRICES = {
    "XXS": 0,
    "XS": 0,
    "S": 0,
    "M": 4.49,
    "L": 6.49,
    "XL": 6.49,
    "custom": 6.99,
};

// Physical print pricing (Hahnemühle paper). Only XS / S / M / L are
// available as prints.
export const PRINT_PRICES = {
    "XS": 14.99,
    "S": 34.99,
    "M": 49.99,
    "L": 94.99,
};

export const PRINT_SIZES = ["XS", "S", "M", "L"];

// Print sizes require a higher DPI than digital — paper has no zoom-out
// to forgive low resolution. Digital remains at 200; print uses 300.
export const PRINT_MIN_DPI = 300;

// Shipping flat rates. Stripe presents both options on the checkout
// page and the customer picks the matching one — we don't try to
// auto-match by detected country (Stripe doesn't support per-country
// shipping_rate gating natively).
export const SHIPPING_RATES = [
    { id: "de",   label: "Germany",         price:  9.99 },
    { id: "rest", label: "Rest of Europe",  price: 15.99 },
];

// Frame catalog: each material has a list of colors and a per-size
// price table. Material "none" is no frame (free, no color picker).
// IDs are stable strings stored in the order / payment metadata.
export const FRAME_MATERIALS = [
    {
        id: "none",
        label: "No frame",
        colors: [],
        prices: { XS: 0, S: 0, M: 0, L: 0 },
    },
    {
        id: "wood_painted",
        label: "Wood (painted)",
        colors: [
            { id: "black", label: "Black", swatch: "#1a1a1a" },
            { id: "white", label: "White", swatch: "#f3f3f3" },
        ],
        prices: { XS: 29.99, S: 39.99, M: 54.99, L: 79.99 },
    },
    {
        id: "wood_oak",
        label: "Wood (oak)",
        colors: [
            { id: "oak", label: "Oak", swatch: "#c08a52" },
        ],
        prices: { XS: 59.99, S: 69.99, M: 119.99, L: 219.99 },
    },
    {
        id: "plastic",
        label: "Plastic",
        colors: [
            { id: "black",  label: "Black",  swatch: "#1a1a1a" },
            { id: "white",  label: "White",  swatch: "#f3f3f3" },
            { id: "silver", label: "Silver", swatch: "#c0c4c8" },
        ],
        prices: { XS: 29.99, S: 39.99, M: 54.99, L: 79.99 },
    },
    {
        id: "alu",
        label: "Aluminium",
        colors: [
            { id: "black",  label: "Black",  swatch: "#1a1a1a" },
            { id: "white",  label: "White",  swatch: "#f3f3f3" },
            { id: "silver", label: "Silver", swatch: "#c0c4c8" },
        ],
        prices: { XS: 34.99, S: 44.99, M: 54.99, L: 69.99 },
    },
];

export function getFrameMaterial(id) {
    return FRAME_MATERIALS.find(m => m.id === id) || FRAME_MATERIALS[0];
}

export function getFramePrice(materialId, size) {
    const mat = getFrameMaterial(materialId);
    return (mat.prices && mat.prices[size]) || 0;
}

// Passepartout (mat border) — free either way, choice of 0 or 3 cm.
export const PASSEPARTOUT_OPTIONS = [
    { value: 0, label: "0 cm" },
    { value: 3, label: "3 cm" },
];

export const FORMATS = {
    "4:3": {
        XXS: "7x5,25",
        XS: "14x10,5",
        S: "28x21",
        M: "40x30",
        L: "80x60",
        XL: "100x75"
    },
    "3:2": {
        XXS: "7,5x5",
        XS: "15x10",
        S: "30x20",
        M: "60x40",
        L: "90x60",
        XL: "105x70"
    },
    "16:9": {
        XXS: "8x4,5",
        XS: "16x9",
        S: "32x18",
        M: "64x36",
        L: "112x64",
        XL: "128x72"
    },
    "DIN": {
        XXS: "7,4x5,2",
        XS: "14,8x10,5",
        S: "29,7x21",
        M: "42x29,7",
        L: "84,1x59,4",
        XL: "118,9x84,1"
    },
    "1:1": {
        XXS: "7,5x7,5",
        XS: "13x13",
        S: "30x30",
        M: "50x50",
        L: "80x80",
        XL: "100x100"
    }
};